import {
  memoizedCreateCartServiceSchedulingForCompletedOrders,
  DEFAULT_RETURN_VALUES,
} from './cartServiceSchedulingFactory';

/** @param {Order} order */
export const useCartServiceSchedulingForCompletedOrders = (order) => {
  if (!order?.cart) {
    return DEFAULT_RETURN_VALUES;
  }

  return memoizedCreateCartServiceSchedulingForCompletedOrders({ cart: order.cart });
};

/** @typedef {import('src/types/order').Order} Order */
